<script>
export default {
    name: "PrintDischargeSummary",

    data() {

        return {
            dischargeSummary: {
                clinicianId:0,
            },
            patient: {},
            prescriptions: [],
            appointments: [],
            signatureUrl:this.$root.companydetails.mainSignatureUrl,
            doctorsignature:{},
        };
    },

    mounted() {

        Promise.allSettled([ 
                this.fetchDischargeSummary(), this.fetchPatient(), 
                this.fetchPrescriptions(), this.fetchAppointments(),
               // this.fetchPatientFiles(),
            ]).then(() => {
                setTimeout(() => {
                    window.print();
                }, 250);
        }).catch(() => {});
    },

    methods: {

        fetchPatient() {
            let url = `PatientRegistration/GetSpecificPatient`;
                url += `?PatientID=${this.$route.query.patientID}`;

            return this.$http.get(url).then(({data}) => {
                this.patient = data.length ? data[0] : {};
            }).catch(() => {});
        },

        fetchAppointments() {
            let url = `MedicalFile/GetPatientAppointments`;
                url += `?PatientID=${this.$route.query.patientID}`;
                url += `&VisitNo=${this.$route.query.visitNo}`;

            return this.$http.get(url).then(({data}) => {
              this.appointments = data;
            }).catch(() => {});
        },

        fetchPrescriptions() {
            let url = `MedicalFile/GetPatientDrugsandConsumblesTreatmentforDischarge`;
                url += `?PatientID=${this.$route.query.patientID}`;
                url += `&VisitNo=${this.$route.query.visitNo}`;

            return this.$http.get(url).then(({data}) => {
                    this.prescriptions = data;
                 }).catch(() => {});
        },
        fetchPatientFiles() {
            let url = `FIles/GetDoctorSignature?ConsultantID=${this.dischargeSummary.clinicianId}`;

            return this.$http.get(url).then(({data}) => {
                this.doctorsignature = data.length ? data[0] : {};
            }).catch(() => {});
        },
        
        fetchDischargeSummary() {
            let url = `Admissions/GetPatientDischargeSummary`;
                url += `?PatientID=${this.$route.query.patientID}&VisitNo=${this.$route.query.visitNo}`;

          return this.$http.get(url).then(response => {
                this.dischargeSummary = response.data.length ? response.data[0] : {};
                this.fetchPatientFiles();
            }).catch(() => {});
        },
       
    },
}
</script>
<template>
 <div class="w-full flex flex-wrap items-center">
     <tail-address-header></tail-address-header>
    <div class="w-full my-2 text-center">
        <h5 class="font-bold text-base capitalize">Discharge Summary </h5>
    </div> 
    <!-- <tail-stamp></tail-stamp> -->
   
    <div class="w-full flex flex-wrap border-t-2 p-2 my-3">
        <div class="w-full p-1">
            <h5 class="font-medium text-sm">Name: {{ patient.names }}</h5>
        </div>
        <div class="w-1/3 p-1">
            <h5 class="font-medium text-sm">MRN: {{ patient.patienT_ID }}</h5>
        </div>
        <div class="w-1/3 p-1">
            <h5 class="font-medium text-sm">IP: {{ patient.ipfileno || `-` }}</h5>
        </div>
        <div class="w-1/3 p-1">
            <h5 class="font-medium text-sm">OP: {{ patient.opfileno || `-` }}</h5>
        </div>
        <div class="w-1/3 p-1">
            <h5 class="font-medium text-sm">DOB: {{ patient.dob | dateFormat }}</h5>
        </div>
        <div class="w-1/3 p-1">
            <h5 class="font-medium text-sm">Age: {{ patient.age || `-` }} Yr(s)</h5>
        </div>
        <div class="w-1/3 p-1">
            <h5 class="font-medium text-sm">Gender: {{ patient.gender }}</h5>
        </div>
    </div>
    <div class="w-full flex flex-wrap p-2 border-t-2">
        <div class="w-1/3">
            <h5 class="font-medium text-sm">Admission Date: 
                {{ dischargeSummary.dateofAdmission | dateFormat }}</h5>
        </div>
        <div class="w-1/3">
            <h5 class="font-medium text-sm">Discharge Date: 
                {{ dischargeSummary.dateofDischarge | dateFormat }}</h5>
        </div>
    </div>
    <div class="w-full flex flex-wrap p-2 border-t-2 border-b-2">
        <!-- <div class="w-full p-1">
            <h5 class="font-medium text-sm my-1">Diagnosis</h5>
        </div> -->
        <div class="w-1/2 p-1">
            <h5 class="font-medium text-sm my-1">Diagnosis On discharge</h5>
            <span class="text-xs my-2" v-html="dischargeSummary.diagnosis || `-`"></span>
        </div>
        <div class="w-full p-1">
            <h5 class="font-medium text-sm my-1">Major/Relevant Presenting Complains and Brief History </h5>
            <span class="text-xs my-2" v-html="dischargeSummary.majorComplaints || `-`"></span>
        </div>
        <div class="w-full p-1">
            <h5 class="font-medium text-sm my-1"> Major/Relevant Physical Findings at Admission</h5>
            <span class="text-xs my-2" v-html="dischargeSummary.physicalFindings || `-`"></span>
        </div> <div class="w-full p-1">
            <h5 class="font-medium text-sm my-1"> Major/Relevant Physical Findings at Discharge</h5>
            <span class="text-xs my-2" v-html="dischargeSummary.physicalFindingsatDischarge || `-`"></span>
        </div>
        <div class="w-full p-1">
            <h5 class="font-medium text-sm my-1">Investigations Done</h5>
            <span class="text-xs my-2" v-html="dischargeSummary.investigationsdone || `-`"></span>
        </div>
        <div class="w-full p-1">
            <h5 class="font-medium text-sm my-1">Diagnosis on Admission</h5>
            <span class="text-xs my-2" v-html="dischargeSummary.diagnosisOnAdmission || `-`"></span> 
        </div>
        
    </div>
    <div class="w-full p-1">
        <h5 class="font-medium my-1 text-sm">Procedures done</h5>
        <span class="text-xs my-2" v-html="dischargeSummary.proceduresdone || `-`"></span>
    </div>
     <div class="w-full p-1">
        <h5 class="font-medium my-1 text-sm">Post Procedures Status</h5>
        <span class="text-xs my-2" v-html="dischargeSummary.postProcedureStatus || `-`"></span>
    </div>
    <div class="w-full p-1" v-if="$root.checkAuth('DisplayDrugReceivedOnDischargeSummary')">
        <h5 class="font-medium my-1 text-sm">Drugs Received</h5>
        <span class="text-xs my-2" v-html="dischargeSummary.drugsReceived || `-`"></span>
    </div>
    <div class="w-full p-1">
        <h5 class="font-medium my-1 text-sm">Condition/Progress on Discharge</h5>
        <span class="text-xs my-2" v-html="dischargeSummary.progress || `-`"></span>
    </div><div class="w-full p-1">
        <h5 class="font-medium my-1 text-sm">Special Instruction</h5>
        <span class="text-xs my-2" v-html="dischargeSummary.specialInstructions || `-`"></span>
    </div><div class="w-full p-1">
        <h5 class="font-medium my-1 text-sm">Warning Signs:Return to Hospital if you Experience</h5>
        <span class="text-xs my-2" v-html="dischargeSummary.warningSigns || `-`"></span>
    </div>
    <div class="w-full p-1">
        <h5 class="font-medium text-sm">Drugs Discharged On</h5>
    </div>
    <div class="w-full p-1">
        <div class="w-full overflow-visible p-1 my-1">
            <table class="table">
                <thead class="text-xs">
                    <tr>
                        <th class="p-tiny">Item</th>
                        <th class="p-tiny">Prescription</th>
                    </tr>
                </thead>
                <tbody class="text-xs">
                    <tr v-for="presc in prescriptions" :key="presc.code">
                        <td class="p-tiny break-words">{{ presc.drug }}</td>
                        <td class="p-tiny break-words">{{ presc.description || `-` }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <span class="mt-2" v-html="dischargeSummary.drugsDischargedOn || `-`"></span>
    </div>
    <div class="w-full p-1">
        <h5 class="font-medium text-sm">Appointments</h5>
    </div>
    <div class="w-full overflow-auto my-1">
        <table class="table">
            <thead class="text-xs">
               <tr class="w-full flex">
                   <th class="p-tiny flex-1">Doctor</th>
                   <th class="p-tiny flex-1">Clinic</th>
                   <th class="p-tiny flex-1">TCA/Review Date</th>
                   <th class="p-tiny flex-1">Time</th>
               </tr> 
            </thead>
            <tbody class="text-xs flex flex-col items-center overflow-visible">
                <tr v-for="(app, idx) in appointments" class="w-full flex" :key="idx">
                    <td class="p-tiny flex-1">{{ app.doctor }}</td>
                    <td class="p-tiny flex-1">{{ app.clinic }}</td>
                    <td class="p-tiny flex-1">{{ app.appointmentDate | dateFormat }}</td>
                    <td class="p-tiny flex-1">{{ app.startTime }}</td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="w-full p-1">
        <h5 class="font-medium text-sm my-1">Comment</h5>
        <span class="text-xs my-2" v-html="dischargeSummary.recommendations || `-`"></span>
    </div>
    <div class="w-full p-1">
        <h5 class="text-base font-medium">Discharged By: {{ dischargeSummary.clinician }}</h5>
          <!-- <tail-signature></tail-signature> -->
         <div class="flex items-right justify-end mr-10 pb-2"  v-if="$root.checkAuth('DisplayPrintedByOnDischargeSummary')" > 
            <h5 class="text-base font-medium">Printed By: {{ this.$root.username }}</h5>
        </div>
            <div class="flex items-center justify-start mr-10 pb-2" > 
              
            <img class="h-70"
              v-if="doctorsignature.signatureID>0"
              :src="`data:application/image;base64,${doctorsignature.document}`"
              :alt="doctorsignature.docName"
            /><img class="h-70"
              v-else
              :src="signatureUrl"
              :alt="Signature"
            />
         </div>    <tail-stamp-right></tail-stamp-right>
         
      </div>
</div>   
</template>
<style scoped>
.h-70 {
    max-height: 5rem;
}
</style>